import { useIsInclude } from "../../RoutersCst";
import { PagesID } from "@utils/utilsConfigurations";

import Corporate from "@pages/Contents/Corporate";

import AddCorporate from "@pages/Contents/Corporate/AddCorporate";
import EditCorporate from "@pages/Contents/Corporate/EditCorporate";
import DetailCorporate from "@pages/Contents/Corporate/DetailCorporate";
import ProtectedRoute from "@components/ProtectedRoute";
import CorporateDetailNestedGuard from "@components/CorporateDetailNestedGuard";

//CORPORATE DETAIL IMPORTS
import useCorporateUser from "./sections/CorporateUser";
import useCorporateBadgeCertificate from "./sections/CorporateBadgeCertificate";
import useCorporateMediaLibrary from "./sections/CorporateMediaLibrary";
import useCorporateInitiative from "./sections/CorporateInitiative";
import useCorporateTerms from "./sections/CorporateTerms";
import useCorporateSkills from "./sections/CorporateSkills";
import useCorporateCatalog from "./sections/CorporateCatalog";
import useCorporateGroups from "./sections/CorporateGroups";
import useCorporateAttributes from "./sections/CorporateAttributes";
import useCorporateEditions from "./sections/CorporateEditions";
import useCorporateLocations from "./sections/CorporateLocations";
import Runtastic from "@pages/Contents/Corporate/Runtastic";
import CorporateDetailV2Layout from "@pages/Shared/CorporateDetailV2Layout";
// import useCorporateQuicksight from "./sections/CorporateQuicksight";
import useCorporateSurvey from "./sections/CorporateSurvey";
import useTeachersArea from "../teachersArea/teachersArea";
import useCorporateNotifications from "./sections/CorporateNotifications";
import useSelfSignupRoutes from "../SelfSignup/SelfSignupRoutes";
import useCorporateTrainingNeeds from "./sections/CorporateTrainingNeeds";
import useCorporateDashboard from "./sections/CorporateDashboard";
import useCorporateFoundedTraining from "./sections/CorporateFoundedTraining";
import useCorporateCollectCampaigns from "./sections/CorporateCollectCampaign";
import useCorporateBudgetManagement from "./sections/CorporateBudgetManagement";
import useCorporateBrandAsset from "./sections/CorporateBrandAsset";

const useCorporateRoutes = () => {
  const { isInclude } = useIsInclude();

  const corporateUser = useCorporateUser();
  const corporateBadgeCertificate = useCorporateBadgeCertificate();
  const corporateMediaLibrary = useCorporateMediaLibrary();
  const corporateInitiative = useCorporateInitiative();
  const corporateTerms = useCorporateTerms();
  const corporateSkills = useCorporateSkills();
  const corportateTrainingNeeds = useCorporateTrainingNeeds();
  const corporateCatalog = useCorporateCatalog();
  const corporateGroups = useCorporateGroups();
  const corporateAttributes = useCorporateAttributes();
  const corporateEditions = useCorporateEditions();
  const corporateLocations = useCorporateLocations();
  // const corporateQuicksight = useCorporateQuicksight();
  const corporateSurvey = useCorporateSurvey();
  const teachersArea = useTeachersArea();
  const corporateNotifications = useCorporateNotifications();
  const selfSignupRoutes = useSelfSignupRoutes();
  const corporateDashboard = useCorporateDashboard();
  const foundedTraining = useCorporateFoundedTraining();
  const corporateCollectCampaigns = useCorporateCollectCampaigns();
  const corporateBudgetManagement = useCorporateBudgetManagement();
  const corporateBrandAsset = useCorporateBrandAsset();

  return {
    path: "corporate",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute isAllowed={isInclude("corporate")}>
            <Corporate />
          </ProtectedRoute>
        ),
      },
      {
        path: "add",
        element: (
          <ProtectedRoute isAllowed={isInclude("corporate")}>
            <AddCorporate />
          </ProtectedRoute>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <ProtectedRoute isAllowed={isInclude("corporate")}>
            <EditCorporate />
          </ProtectedRoute>
        ),
      },
      {
        path: ":id",
        element: <CorporateDetailNestedGuard />,
        children: [
          {
            path: "runtastic",
            element: (
              <ProtectedRoute isAllowed={isInclude("corporate")}>
                <Runtastic />
              </ProtectedRoute>
            ),
          },
          {
            path: "detail",
            element: <CorporateDetailV2Layout />,
            children: [
              {
                index: true,
                path: "",
                loader: () => ({
                  title: PagesID["corporate.detail"],
                }),
                element: (
                  <ProtectedRoute isAllowed={isInclude("corporate")}>
                    <DetailCorporate />
                  </ProtectedRoute>
                ),
              },
              //CHILDREN SECTION
              ...corporateUser, //USER AND CUSTOM FIELD
              corporateBadgeCertificate, //BADGES AND CERTIFICATES
              corporateMediaLibrary, //MEDIA LIBRARY
              corporateInitiative, //INITIATIVE
              corporateTerms, //TERMS
              corporateSkills, //SKILLS
              corportateTrainingNeeds, //TRAINING NEEDS
              corporateCatalog, //CATALOG
              ...corporateGroups, //GROUPS
              ...corporateAttributes, //ATTRIBUTES
              ...corporateEditions, //EDITIONS
              corporateLocations, //LOCATIONS
              // corporateQuicksight, //QUICKSIGHT
              corporateSurvey, //SURVEY
              teachersArea, //TEACHERS
              corporateNotifications, //NOTIFICATIONS
              selfSignupRoutes, // SELF-SIGNUP
              corporateDashboard, // DASHBOARD
              foundedTraining, //FOUNDED-TREANING
              corporateCollectCampaigns, //COLLECT-CAMPAIGNS
              corporateBudgetManagement, //BUDGET MANAGEMENT
              corporateBrandAsset, //CORPORATE BRAND ASSET
            ],
          },
        ],
      },
    ],
  };
};

export default useCorporateRoutes;
